/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component, Input } from '@angular/core';

@Component({
  selector: 'ut-tab',
  template: `
    <div
      class="tab-pane"
      [class.active]="active"
      [hidden]="!active"
      [attr.role]="'tabpanel'"
      [attr.id]="'tab-panel-' + tabId">
      <ng-content></ng-content>
    </div>
  `,
  standalone: false,
})
export class TabComponent {
  @Input() tabId!: string;
  @Input() label!: string;
  @Input() active = false;
}
